import { TextContent } from './useIntroBanner';
import cn from 'classnames';
import { safeContent } from 'utils';
import { TextBalancer } from 'components/common';

interface BannerTextProps extends TextContent {
  centered?: boolean;
}

const BannerText = ({
  headline,
  title,
  caption,
  description,
  centered,
}: BannerTextProps) => {
  return (
    <>
      {headline && (
        <h2
          className={cn(
            'tw-font-therebrat tw-mb-0 lg:tw-mb-2 tw-text-white tw-tracking-wide tw-text-[2.625rem] sm:tw-text-[3.5rem] md:tw-text-6xl xl:tw-text-7xl tw-font-medium tw-leading-tight sm:tw-leading-heading tw-text-shadow',
            centered && 'tw-text-center md:tw-text-left',
          )}
        >
          {headline}
        </h2>
      )}
      <TextBalancer
        as="h1"
        className={cn(
          'text-white tw-text-[4.25rem] sm:tw-text-7xl md:tw-text-8xl xl:tw-text-9xl tw-font-black tw-leading-heading tw-text-shadow tw-mb-0',
          centered && 'tw-text-center md:tw-text-left',
        )}
        dangerouslySetInnerHTML={safeContent(title)}
      />
      {caption && (
        <h2 className="tw-mb-0 tw-text-white tw-text-[2.625rem] sm:tw-text-[3.5rem] md:tw-text-6xl xl:tw-text-7xl tw-font-black tw-leading-heading tw-text-shadow tw-my-1">
          {caption}
        </h2>
      )}
      {description && (
        <h3
          className={cn(
            'tw-text-white tw-text-[1.6rem] lg:tw-text-[1.8rem] tw-mt-4 tw-font-normal tw-text-shadow tw-leading-heading tw-mb-2',
            centered && 'tw-text-center md:tw-text-left',
          )}
          dangerouslySetInnerHTML={safeContent(description)}
        />
      )}
    </>
  );
};

export default BannerText;
